/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Error_Nav_Timing_Errors_OptionInputs */

const en_error_nav_timing_errors_option = /** @type {(inputs: Error_Nav_Timing_Errors_OptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Timing Errors`)
};

const fr_error_nav_timing_errors_option = /** @type {(inputs: Error_Nav_Timing_Errors_OptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Erreurs de synchronisation`)
};

const de_error_nav_timing_errors_option = /** @type {(inputs: Error_Nav_Timing_Errors_OptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zeitfehler`)
};

const it_error_nav_timing_errors_option = /** @type {(inputs: Error_Nav_Timing_Errors_OptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Errori di temporizzazione`)
};

const ru_error_nav_timing_errors_option = /** @type {(inputs: Error_Nav_Timing_Errors_OptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ошибки синхронизации`)
};

const es_error_nav_timing_errors_option = /** @type {(inputs: Error_Nav_Timing_Errors_OptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Errores de sincronización`)
};

const zh_cn2_error_nav_timing_errors_option = /** @type {(inputs: Error_Nav_Timing_Errors_OptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`计时误差`)
};

const ja_error_nav_timing_errors_option = /** @type {(inputs: Error_Nav_Timing_Errors_OptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`タイミングエラー`)
};

const hi_error_nav_timing_errors_option = /** @type {(inputs: Error_Nav_Timing_Errors_OptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`समय संबंधी त्रुटियाँ`)
};

const pt_pt2_error_nav_timing_errors_option = /** @type {(inputs: Error_Nav_Timing_Errors_OptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Erros de temporização`)
};

/**
* | output |
* | --- |
* | "Timing Errors" |
*
* @param {Error_Nav_Timing_Errors_OptionInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const error_nav_timing_errors_option = /** @type {((inputs?: Error_Nav_Timing_Errors_OptionInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Error_Nav_Timing_Errors_OptionInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_error_nav_timing_errors_option(inputs)
	if (locale === "de") return de_error_nav_timing_errors_option(inputs)
	if (locale === "it") return it_error_nav_timing_errors_option(inputs)
	if (locale === "ru") return ru_error_nav_timing_errors_option(inputs)
	if (locale === "es") return es_error_nav_timing_errors_option(inputs)
	if (locale === "zh-CN") return zh_cn2_error_nav_timing_errors_option(inputs)
	if (locale === "ja") return ja_error_nav_timing_errors_option(inputs)
	if (locale === "hi") return hi_error_nav_timing_errors_option(inputs)
	if (locale === "pt-PT") return pt_pt2_error_nav_timing_errors_option(inputs)
	return en_error_nav_timing_errors_option(inputs)
});